module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showPage) ? _c('div', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "header",
    attrs: {
      "id": "header"
    }
  }, [(!_vm.schoolLock) ? _c('span', {
    staticClass: "choose-school",
    on: {
      "click": _vm.chooseSchool
    }
  }, [_c('span', {
    staticClass: "ellipse"
  }, [_vm._v(_vm._s(_vm.schoolInfo.schoolName))])]) : _c('span', {
    staticClass: "choose-school no-choose"
  }, [_c('span', {
    staticClass: "ellipse"
  }, [_vm._v(_vm._s(_vm.schoolInfo.schoolName))])]), _vm._v(" "), _c('span', {
    staticClass: "to-search",
    on: {
      "click": _vm.toSearch
    }
  }, [_vm._v("搜索")])]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [(_vm.banners.length > 0) ? _c('div', {
    staticClass: "banner card",
    attrs: {
      "id": "banner"
    }
  }, [(_vm.banners.length > 1) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "swiper-container banner-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.banners), function(item) {
    return _c('div', {
      staticClass: "swiper-slide",
      staticStyle: {
        "padding": "0 .2rem",
        "position": "relative"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "100%",
        "height": "100%",
        "border-radius": ".16rem"
      },
      attrs: {
        "src": item.imageUrl
      }
    }), _vm._v(" "), (item.type == 500085) ? _c('wx-open-launch-weapp', {
      staticStyle: {
        "position": "absolute",
        "width": "100%",
        "height": "100%",
        "top": "0",
        "left": "0"
      },
      attrs: {
        "username": JSON.parse(item.data).miniProgramId,
        "path": JSON.parse(item.data).path
      }
    }, [_c('script', {
      attrs: {
        "type": "text/wxtag-template"
      }
    }, [_vm._v("\n                    <style>.btn {padding: 100px 50px;color: transparent;border: none;background: transparent}</style>\n                    <button class=\"btn\"></button>\n                  ")])]) : _vm._e()], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  })]) : _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "position": "relative"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "border-radius": ".16rem"
    },
    attrs: {
      "src": _vm.banners[0].imageUrl
    },
    on: {
      "click": function($event) {
        return _vm.bannerJump(_vm.banners[0], '118', 'click_home_top_banner')
      }
    }
  }), _vm._v(" "), (_vm.banners[0].type == 500085) ? _c('wx-open-launch-weapp', {
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "height": "100%",
      "top": "0",
      "left": "0"
    },
    attrs: {
      "username": JSON.parse(_vm.banners[0].data).miniProgramId,
      "path": JSON.parse(_vm.banners[0].data).path
    }
  }, [_c('script', {
    attrs: {
      "type": "text/wxtag-template"
    }
  }, [_vm._v("\n              <style>.btn {padding: 100px 50px;color: transparent;border: none;background: transparent}</style>\n              <button class=\"btn\"></button>\n            ")])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.isOpenA) ? _c('div', [(_vm.tagList.length > 0 || _vm.shopList.length > 0) ? _c('div', [(_vm.tagList.length > 0) ? _c('div', {
    staticClass: "category-list"
  }, [_c('ul', {
    staticClass: "card shop-list"
  }, _vm._l((_vm.tagList), function(item) {
    return _c('li', {
      staticStyle: {
        "position": "relative"
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.toGoHomePage(item, 1)
        }
      }
    }, [_c('span', {
      staticClass: "icon",
      style: ({
        backgroundImage: 'url(' + item.show_icon + ')'
      })
    }), _vm._v(" "), _c('span', {
      staticClass: "ellipse",
      staticStyle: {
        "display": "block",
        "font-size": ".22rem",
        "color": "#666",
        "height": ".28rem"
      }
    }, [_vm._v(_vm._s(item.show_name))])]), _vm._v(" "), (item.app_jump_type == 500085) ? _c('wx-open-launch-weapp', {
      staticStyle: {
        "position": "absolute",
        "width": "100%",
        "height": "100%",
        "top": "0",
        "left": "0"
      },
      attrs: {
        "username": JSON.parse(item.app_jump_params).miniProgramId,
        "path": JSON.parse(item.app_jump_params).path
      }
    }, [_c('script', {
      attrs: {
        "type": "text/wxtag-template"
      }
    }, [_vm._v("\n                    <style>.btn {padding: 24px 12px;color: transparent;border: none;background: transparent}</style>\n                    <button class=\"btn\"></button>\n                  ")])]) : _vm._e()], 1)
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.noticeContent && _vm.noticeContent != '') ? _c('div', {
    staticClass: "marquee",
    on: {
      "click": _vm.getNoticeDetail
    }
  }, [_c('div', {
    staticClass: "marquee_bg card tag-list"
  }, [_c('span', {
    staticClass: "notice_icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "marquee-box"
  }, [_c('div', [_c('p', {
    attrs: {
      "id": "marquee-dom"
    }
  }, [_vm._v(_vm._s(_vm.noticeContent))])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "lantern-slide lantern-list"
  }, _vm._l((_vm.lanternSlideList), function(item2) {
    return _c('div', {
      staticClass: "card",
      on: {
        "click": function($event) {
          return _vm.lanternSlideJump(item2)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item2.show_icon,
        "width": "100%"
      }
    })])
  }), 0), _vm._v(" "), (_vm.shopList.length > 0) ? _c('div', {
    staticClass: "goods-list card"
  }, [_c('div', {
    staticClass: "goods-title"
  }, [_vm._v("本校食堂")]), _vm._v(" "), _c('ul', _vm._l((_vm.shopList), function(item) {
    return _c('li', {
      staticStyle: {
        "padding": "0.2rem 0 0 0",
        "position": "relative"
      }
    }, [_c('div', {
      staticClass: "goods-box",
      on: {
        "click": function($event) {
          return _vm.toGoHomePage(item)
        }
      }
    }, [_c('a', [_c('div', {
      staticClass: "lazy shopimg fl",
      style: ({
        backgroundImage: 'url(' + item.show_icon + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "shopname fl"
    }, [_vm._v(_vm._s(item.show_name))]), _vm._v(" "), (item.app_jump_type == 500085) ? _c('wx-open-launch-weapp', {
      staticStyle: {
        "position": "absolute",
        "width": "100%",
        "height": "100%",
        "top": "0",
        "left": "0"
      },
      attrs: {
        "username": JSON.parse(item.app_jump_params).miniProgramId,
        "path": JSON.parse(item.app_jump_params).path
      }
    }, [_c('script', {
      attrs: {
        "type": "text/wxtag-template"
      }
    }, [_vm._v("\n                        <style>.btn {padding: 24px 12px;color: transparent;border: none;background: transparent}</style>\n                        <button class=\"btn\"></button>\n                      ")])]) : _vm._e()], 1)])])
  }), 0)]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isOpenA) ? _c('div', [(_vm.shopCategoryList.length > 0) ? _c('div', {
    ref: "categoryList",
    staticClass: "category-list"
  }, [_c('ul', {
    staticClass: "card shop-list"
  }, _vm._l((_vm.shopCategoryList), function(item, index) {
    return _c('li', {
      key: index,
      staticStyle: {
        "position": "relative"
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.toShopList(item)
        }
      }
    }, [_c('span', {
      staticClass: "icon",
      style: (item.backgroundimg)
    }), _vm._v(" "), _c('span', {
      staticClass: "ellipse c-666 fs-22",
      staticStyle: {
        "display": "block",
        "height": ".28rem"
      }
    }, [_vm._v(_vm._s(item.show_name))]), _vm._v(" "), (item.app_jump_type == 500085) ? _c('wx-open-launch-weapp', {
      staticStyle: {
        "position": "absolute",
        "width": "100%",
        "height": "100%",
        "top": "0",
        "left": "0"
      },
      attrs: {
        "username": JSON.parse(item.app_jump_params).miniProgramId,
        "path": JSON.parse(item.app_jump_params).path
      }
    }, [_c('script', {
      attrs: {
        "type": "text/wxtag-template"
      }
    }, [_vm._v("\n                    <style>.btn {padding: 24px 12px;color: transparent;border: none;background: transparent}</style>\n                    <button class=\"btn\"></button>\n                  ")])]) : _vm._e()], 1)])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.noticeContent && _vm.noticeContent != '') ? _c('div', {
    staticClass: "marquee",
    on: {
      "click": _vm.getNoticeDetail
    }
  }, [_c('div', {
    staticClass: "marquee_bg card tag-list"
  }, [_c('span', {
    staticClass: "notice_icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "marquee-box"
  }, [_c('div', [_c('p', {
    attrs: {
      "id": "marquee-dom"
    }
  }, [_vm._v(_vm._s(_vm.noticeContent))])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "lantern-slide lantern-list"
  }, _vm._l((_vm.lanternSlideList), function(item2) {
    return _c('div', {
      staticClass: "card",
      on: {
        "click": function($event) {
          return _vm.lanternSlideJump(item2)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item2.show_icon,
        "width": "100%"
      }
    })])
  }), 0), _vm._v(" "), (_vm.benefitList.length > 0) ? _c('div', {
    staticClass: "benefit card",
    attrs: {
      "id": "benefit"
    }
  }, [(_vm.benefitList.length > 1) ? _c('div', [_c('div', {
    staticClass: "swiper-container benefit-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.benefitList), function(item) {
    return _c('div', {
      staticClass: "swiper-slide",
      staticStyle: {
        "padding": ".20rem",
        "position": "relative"
      }
    }, [_c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('div', {
      staticClass: "item-img",
      on: {
        "click": function($event) {
          return _vm.benefitJump(item)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "width": "2.0rem",
        "height": "3.5rem"
      },
      attrs: {
        "src": item.pic
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "item-desc"
    }, [_c('div', [_c('div', {
      staticClass: "name ellipses",
      staticStyle: {
        "font-size": ".32rem",
        "font-weight": "600"
      },
      on: {
        "click": function($event) {
          return _vm.benefitJump(item)
        }
      }
    }, [_vm._v(_vm._s(item.shop_name))]), _vm._v(" "), _c('div', {
      staticClass: "item-tag"
    }, [(item.is_open == 1) ? _c('span', [(item.is_book == 1) ? _c('span', {
      staticClass: "shop-status can-reserve"
    }, [_vm._v("可预订")]) : _c('span', {
      staticClass: "shop-status"
    }, [_vm._v("营业中")])]) : _c('span', {
      staticClass: "shop-status close"
    }, [_vm._v("已打烊")])])]), _vm._v(" "), _c('div', {
      staticClass: "flex-row-bc",
      staticStyle: {
        "margin-top": "0.03rem"
      }
    }, [_c('div', {
      staticClass: "fs-22 flex-row-cc"
    }, [_c('img', {
      staticClass: "star",
      staticStyle: {
        "width": ".24rem",
        "height": ".24rem"
      },
      attrs: {
        "src": require("../assets/images/icon-star.png")
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-right": ".10rem",
        "font-size": ".26rem",
        "color": "#FFB300"
      }
    }, [_vm._v(_vm._s(item.score))]), _vm._v(" "), _c('span', {
      staticClass: "argver"
    }, [_vm._v("月售" + _vm._s(item.sales_append) + "单")])]), _vm._v(" "), (item.dinnerDuration) ? _c('span', {
      staticClass: "argver"
    }, [_vm._v(_vm._s(item.dinnerDuration))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "scroller",
      staticStyle: {
        "margin-top": "0.05rem"
      }
    }, [(item.promotion_list && item.promotion_list.length > 0) ? _c('span', {
      staticClass: "item-imgs"
    }, _vm._l((item.promotion_list), function(pro) {
      return (item.promotion_list) ? _c('img', {
        staticStyle: {
          "width": ".30rem",
          "margin-right": ".10rem"
        },
        attrs: {
          "src": pro.icon_url,
          "mode": "widthFix"
        }
      }) : _vm._e()
    }), 0) : _vm._e(), _vm._v(" "), (item.promotion_package && item.promotion_package.length > 0) ? _c('span', {
      staticClass: "item-package"
    }, _vm._l((item.promotion_package), function(package) {
      return _c('div', [_vm._v(_vm._s(package.package_desc))])
    }), 0) : _vm._e(), _vm._v(" "), (item.promotion_reduce && item.promotion_reduce.reduce_info && item.promotion_reduce.reduce_info.length > 0) ? _c('span', {
      staticClass: "item-promotion"
    }, _vm._l((item.promotion_reduce.reduce_info), function(promotion) {
      return _c('div', {
        staticClass: "reduce"
      }, [_vm._v(_vm._s(promotion.meet_price) + "减" + _vm._s(promotion.cut_price))])
    }), 0) : _vm._e(), _vm._v(" "), (item.coupon_list && item.coupon_list.length > 0) ? _c('span', {
      staticClass: "item-coupon"
    }, [_vm._l((item.coupon_list), function(coupon) {
      return _c('div', {
        staticClass: "desc"
      }, [_vm._v("\n                            " + _vm._s(coupon.couponDes) + "\n                          ")])
    }), _vm._v(" "), _c('span', {
      staticClass: "get"
    }, [_vm._v("领券")])], 2) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "flex-row-bs",
      staticStyle: {
        "margin-top": "0.1rem"
      }
    }, _vm._l((item.goods), function(good) {
      return _c('div', [_c('div', {
        staticClass: "flex-colum-ss"
      }, [_c('img', {
        staticStyle: {
          "width": "1.38rem",
          "height": "1.38rem"
        },
        attrs: {
          "src": good.thumbnail
        },
        on: {
          "click": function($event) {
            return _vm.goodsJump(item, good)
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "ellipses",
        staticStyle: {
          "font-size": ".24rem",
          "width": "1.38rem",
          "margin-top": ".12rem",
          "color": "#333"
        }
      }, [_vm._v(_vm._s(good.gdName))]), _vm._v(" "), _c('div', {
        staticClass: "fs-20",
        staticStyle: {
          "color": "#FD394F",
          "margin-top": ".04rem"
        }
      }, [_vm._v("￥"), _c('span', {
        staticClass: "fs-28",
        staticStyle: {
          "color": "#FD394F"
        }
      }, [_vm._v(_vm._s(good.salePrice))])])])])
    }), 0)])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  })]) : _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "position": "relative",
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "item-img",
    on: {
      "click": function($event) {
        return _vm.benefitJump(_vm.benefitList[0])
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "2.0rem",
      "height": "3.5rem"
    },
    attrs: {
      "src": _vm.benefitList[0].pic
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-desc"
  }, [_c('div', [_c('div', {
    staticClass: "name ellipses",
    staticStyle: {
      "font-size": ".32rem"
    },
    on: {
      "click": function($event) {
        return _vm.benefitJump(_vm.benefitList[0])
      }
    }
  }, [_vm._v(_vm._s(_vm.benefitList[0].shop_name))]), _vm._v(" "), _c('div', {
    staticClass: "item-tag"
  }, [(_vm.benefitList[0].is_open == 1) ? _c('span', [(_vm.benefitList[0].is_book == 1) ? _c('span', {
    staticClass: "shop-status can-reserve"
  }, [_vm._v("可预订")]) : _c('span', {
    staticClass: "shop-status"
  }, [_vm._v("营业中")])]) : _c('span', {
    staticClass: "shop-status close"
  }, [_vm._v("已打烊")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-row-bc",
    staticStyle: {
      "margin-top": ".12rem"
    }
  }, [_c('div', {
    staticClass: "fs-22 flex-row-cc"
  }, [_c('img', {
    staticClass: "star",
    staticStyle: {
      "width": ".24rem",
      "height": ".24rem"
    },
    attrs: {
      "src": require("../assets/images/icon-star.png")
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-right": ".10rem",
      "font-size": ".26rem",
      "color": "#FFB300"
    }
  }, [_vm._v(_vm._s(_vm.benefitList[0].score))]), _vm._v(" "), _c('span', {
    staticClass: "argver"
  }, [_vm._v("月售" + _vm._s(_vm.benefitList[0].sales_append) + "单")])]), _vm._v(" "), (_vm.benefitList[0].dinnerDuration) ? _c('span', {
    staticClass: "argver"
  }, [_vm._v(_vm._s(_vm.benefitList[0].dinnerDuration))]) : _vm._e()]), _vm._v(" "), (_vm.benefitList && _vm.benefitList.length > 0) ? _c('div', {
    staticClass: "scroller",
    staticStyle: {
      "margin-top": ".14rem"
    }
  }, [(_vm.benefitList[0].promotion_list && _vm.benefitList[0].promotion_list.length > 0) ? _c('span', {
    staticClass: "item-imgs"
  }, [_vm._l((_vm.benefitList[0].promotion_list), function(pro) {
    return (_vm.benefitList[0].promotion_list) ? _c('img', {
      staticStyle: {
        "width": ".30rem",
        "margin-right": ".10rem"
      },
      attrs: {
        "src": pro.icon_url,
        "mode": "widthFix"
      }
    }) : _vm._e()
  }), _vm._v(" "), (_vm.benefitList[0].showMsg) ? _c('span', [_vm._v(_vm._s(_vm.benefitList[0].promotion_list[0].promotion_name))]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.benefitList[0].promotion_package && _vm.benefitList[0].promotion_package.length > 0) ? _c('span', {
    staticClass: "item-package"
  }, _vm._l((_vm.benefitList[0].promotion_package), function(package) {
    return _c('span', [_vm._v(_vm._s(package.package_desc))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.benefitList[0].promotion_reduce && _vm.benefitList[0].promotion_reduce.reduce_info && _vm.benefitList[0].promotion_reduce.reduce_info.length > 0) ? _c('span', {
    staticClass: "item-promotion"
  }, _vm._l((_vm.benefitList[0].promotion_reduce.reduce_info), function(promotion) {
    return _c('span', {
      staticClass: "reduce"
    }, [_vm._v(_vm._s(promotion.meet_price) + "减" + _vm._s(promotion.cut_price))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.benefitList[0].coupon_list && _vm.benefitList[0].coupon_list.length > 0) ? _c('span', {
    staticClass: "item-coupon"
  }, [_vm._l((_vm.benefitList[0].coupon_list), function(coupon) {
    return _c('div', {
      staticClass: "desc"
    }, [_vm._v("\n                      " + _vm._s(coupon.couponDes) + "\n                    ")])
  }), _vm._v(" "), _c('span', {
    staticClass: "get"
  }, [_vm._v("领券")])], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-row-bs",
    staticStyle: {
      "margin-top": ".08rem"
    }
  }, _vm._l((_vm.benefitList[0].goods), function(good) {
    return _c('div', [_c('div', {
      staticClass: "flex-colum-ss"
    }, [_c('img', {
      staticStyle: {
        "width": "1.38rem",
        "height": "1.38rem"
      },
      attrs: {
        "src": good.thumbnail
      },
      on: {
        "click": function($event) {
          return _vm.goodsJump(_vm.benefitList[0], good)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "ellipses",
      staticStyle: {
        "font-size": ".24rem",
        "width": "1.38rem",
        "margin-top": ".12rem",
        "color": "#333"
      }
    }, [_vm._v(_vm._s(good.gdName))]), _vm._v(" "), _c('div', {
      staticClass: "fs-20",
      staticStyle: {
        "color": "#FD394F",
        "margin-top": ".04rem"
      }
    }, [_vm._v("￥"), _c('span', {
      staticClass: "fs-28",
      staticStyle: {
        "color": "#FD394F"
      }
    }, [_vm._v(_vm._s(good.salePrice))])])])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.isOpenOrder) ? _c('div', [_c('div', {
    staticClass: "goods-title1 flex-colum-ss",
    class: _vm.isFixed ? 'fixed' : '',
    style: ({
      top: _vm.headerHeight + 'px'
    }),
    attrs: {
      "id": "goods-title1"
    }
  }, [_c('div', {
    staticClass: "shop-title"
  }, _vm._l((_vm.shopTitles), function(item) {
    return _c('div', {
      staticClass: "item",
      class: item.checked ? 'active' : '',
      on: {
        "click": function($event) {
          return _vm.switchTitle(item)
        }
      }
    }, [_vm._v("\n                " + _vm._s(item.title) + "\n                "), _c('span')])
  }), 0), _vm._v(" "), (!_vm.currentTitle) ? _c('div', {
    staticClass: "shop-title1 flex-row-bc-w"
  }, _vm._l((_vm.shopSorts), function(item) {
    return _c('div', {
      staticClass: "item1",
      class: item.checked ? 'active' : '',
      style: ({
        backgroundColor: _vm.isFixed ? '#f8f8f8' : ''
      }),
      on: {
        "click": function($event) {
          return _vm.switchSort(item)
        }
      }
    }, [_vm._v("\n                " + _vm._s(item.title) + "\n              ")])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "goods-list shop card",
    staticStyle: {
      "min-height": "15rem"
    },
    attrs: {
      "id": "goods-list"
    }
  }, [(_vm.currentShopList.length) ? _c('ul', {
    staticClass: "goods-ul",
    staticStyle: {
      "min-height": "100vh"
    }
  }, _vm._l((_vm.currentShopList), function(item, index4) {
    return _c('li', {
      key: index4,
      staticStyle: {
        "padding": "0.2rem 0"
      }
    }, [_c('div', {
      staticClass: "goods-box"
    }, [_c('a', [_c('div', {
      staticClass: "goods-img",
      on: {
        "click": function($event) {
          return _vm.toGoodsList(item.id, item.shop_name)
        }
      }
    }, [_c('div', {
      staticClass: "lazy goodimg",
      style: (item.backgroundimg)
    }), _vm._v(" "), (item.is_mark == 1) ? _c('div', {
      staticClass: "mark",
      style: ({
        backgroundColor: item.mark_color
      })
    }, [_vm._v("\n                        " + _vm._s(item.mark) + "\n                      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "goods-des",
      on: {
        "click": function($event) {
          return _vm.toGoodsList(item.id, item.shop_name)
        }
      }
    }, [_c('div', {
      staticClass: "name ellipse"
    }, [_vm._v(_vm._s(item.shop_name))]), _vm._v(" "), _c('div', {
      staticClass: "comment",
      staticStyle: {
        "margin-top": "0.03rem"
      }
    }, [_c('img', {
      staticClass: "star",
      attrs: {
        "src": require("../assets/images/icon-star.png")
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#FEC300"
      }
    }, [_vm._v(_vm._s(item.score))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#E3E3E3"
      }
    }, [_vm._v("|")]), _vm._v(" "), _c('span', [_vm._v("月售 " + _vm._s(item.sales_append) + "单")])]), _vm._v(" "), _c('div', {
      staticClass: "flex-row-bc"
    }, [_c('div', {
      staticClass: "flex-row-sc"
    }, [_c('span', {
      staticStyle: {
        "margin-right": "0.05rem"
      }
    }, [_vm._v("起送￥" + _vm._s(item.threshold_amount))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#E3E3E3",
        "margin-right": "0.05rem"
      }
    }, [_vm._v("|")]), _vm._v(" "), (item.delivery_fee_text) ? _c('span', [_vm._v(_vm._s(item.delivery_fee_text))]) : [_c('span', [_vm._v("配送￥")]), _vm._v(" "), (item.new_delivery_fee || item.new_delivery_fee === 0) ? _c('span', [_vm._v(_vm._s(item.new_delivery_fee))]) : _c('span', [_vm._v(_vm._s(item.delivery_fee))]), _vm._v(" "), (item.is_many_delivery == 1) ? _c('span', [_vm._v("起")]) : _vm._e()], _vm._v(" "), (item.new_delivery_fee || item.new_delivery_fee === 0) ? [_c('span', {
      staticStyle: {
        "color": "#999",
        "text-decoration": "line-through",
        "margin-right": "0"
      }
    }, [_vm._v("￥" + _vm._s(item.delivery_fee))])] : _vm._e(), _vm._v(" "), (item.delivery_type == 1) ? _c('span', [_vm._v("(商家配送)")]) : _vm._e()], 2), _vm._v(" "), (item.dinnerDuration) ? _c('div', [_vm._v(_vm._s(item.dinnerDuration))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "flex-row-bc"
    }, [(item.vice_title) ? _c('div', {
      staticClass: "vice_title"
    }, [_vm._v(_vm._s(item.vice_title))]) : _vm._e(), _vm._v(" "), (item.zsd) ? _c('div', {
      staticClass: "punctual-arrive"
    }, [_vm._v(_vm._s(item.zsd))]) : _vm._e()]), _vm._v(" "), (item.promotion_reduce && item.promotion_reduce.reduce_info) ? _c('div', {
      staticClass: "promotion_reduce",
      staticStyle: {
        "padding-left": "0.2rem"
      }
    }, _vm._l((item.promotion_reduce.reduce_info), function(item2, index3) {
      return _c('span', {
        key: index3,
        staticClass: "promotion_reduce-type border"
      }, [_vm._v(_vm._s(item2.meet_price) + "减" + _vm._s(item2.cut_price))])
    }), 0) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "promotion-and-coupon",
      staticStyle: {
        "margin": ".1rem 0 0 2.2rem"
      }
    }, [(item.promotion_list && item.promotion_list.length > 0) ? _c('div', {
      staticClass: "promotion"
    }, _vm._l((item.promotion_list), function(pro) {
      return _c('img', {
        staticClass: "icon",
        attrs: {
          "src": pro.icon_url,
          "width": "100%"
        }
      })
    }), 0) : _vm._e(), _vm._v(" "), (item.promotion_package && item.promotion_package.length > 0) ? _c('div', {
      staticClass: "package"
    }, [_vm._l((item.promotion_package), function(proPackage, index5) {
      return _c('span', {
        key: index5
      }, [_vm._v(_vm._s(proPackage.package_desc))])
    }), _vm._v(" "), (item.showMsg) ? _c('span', [_vm._v(_vm._s(item.promotion_list[0].promotion_name))]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (item.coupon_list && item.coupon_list.length > 0) ? _c('div', {
      staticClass: "coupon"
    }, [_vm._l((item.coupon_list), function(coupon, index6) {
      return _c('span', {
        key: index6,
        staticClass: "desc"
      }, [_vm._v(_vm._s(coupon.couponDes))])
    }), _vm._v(" "), _c('span', {
      staticClass: "get"
    }, [_vm._v("领券")])], 2) : _vm._e()]), _vm._v(" "), (item.is_open == 1) ? _c('span', [(item.is_book == 1) ? _c('span', {
      staticClass: "shop-status can-reserve"
    }, [_vm._v("可预订")]) : _c('span', {
      staticClass: "shop-status"
    }, [_vm._v("营业中")])]) : _c('span', {
      staticClass: "shop-status close"
    }, [_vm._v("已打烊")]), _vm._v(" "), _c('div', {
      staticClass: "shop-type-box"
    }, [(item.is_self_take_new == 1) ? _c('span', {
      staticClass: "shop-type border"
    }, [_vm._v("自提")]) : _vm._e(), _vm._v(" "), (item.is_take_out == 1) ? _c('span', {
      staticClass: "shop-type border"
    }, [_vm._v("外送")]) : _vm._e(), _vm._v(" "), (item.is_eat_in == 1) ? _c('span', {
      staticClass: "shop-type eat-in border"
    }, [_vm._v("堂食")]) : _vm._e()])])])])
  }), 0) : _vm._e()]), _vm._v(" "), (_vm.currentShopList.length == 0 && _vm.noData) ? _c('div', {
    staticClass: "my-content"
  }, [_c('img', {
    staticStyle: {
      "width": "2.00rem",
      "height": "2.74rem",
      "margin": "auto"
    },
    attrs: {
      "src": require("../assets/images/wait.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("暂时没有符合条件的店铺去其他分类看看吧~")])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isOpenOrder) ? _c('div', {
    staticClass: "clearflow",
    staticStyle: {
      "height": "100vh",
      "background": "#fff"
    }
  }, [_c('div', {
    staticClass: "empty-school"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/empty-00.png")
    }
  }), _vm._v(" "), (!_vm.isjdlw) ? _c('h3', {
    staticStyle: {
      "font-weight": "normal",
      "margin": "0"
    }
  }, [_vm._v("业务筹备中")]) : _vm._e(), _vm._v(" "), (_vm.isjdlw) ? _c('p', {
    staticStyle: {
      "font-size": ".24rem"
    }
  }, [_vm._v("亲爱的同学，你的学校当前尚未开通，我们全力开拓中，敬请期待~")]) : _vm._e(), _vm._v(" "), (!_vm.isYSF) ? _c('p', {
    staticStyle: {
      "font-size": "0.26rem",
      "color": "#787878"
    }
  }, [_vm._v("请下载APP体验更多服务")]) : _vm._e(), _vm._v(" "), (!_vm.isYSF) ? _c('div', {
    staticClass: "btn btn-main",
    staticStyle: {
      "margin": "0",
      "padding": "0.22rem 0.72rem",
      "border-radius": "10rem"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#000",
      "font-size": "0.32rem"
    },
    attrs: {
      "href": "https://dl.anlaiye.com"
    }
  }, [_vm._v("下载APP")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.showBottomTips) ? _c('div', {
    staticClass: "bottomTips",
    staticStyle: {
      "bottom": "1.3rem"
    }
  }, [_c('p', [_vm._v("上海鎏帑网络科技有限公司 沪ICP备18024716号-1")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v(" 联系电话：021-60761299")])]) : _vm._e()]), _vm._v(" "), (_vm.showCouponAlert) ? _c('div', {
    staticClass: "notice_detail_alert coupon",
    on: {
      "click": function($event) {
        _vm.showCouponAlert = false
      }
    }
  }, [_c('div', {
    staticClass: "notice_detail_content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [(_vm.couponInfo.partner == 3) ? _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.couponInfo.target_title))]) : _vm._e(), _vm._v(" "), (_vm.couponInfo.partner == 2) ? _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.couponInfo.new_title))]) : _vm._e(), _vm._v(" "), (_vm.couponInfo.partner == 1) ? _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.couponInfo.old_title))]) : _vm._e(), _vm._v(" "), (_vm.couponInfo.partner == 0) ? _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.couponInfo.all_title))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, _vm._l((_vm.couponInfo.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "flex-row-bc"
    }, [_c('div', {
      staticClass: "flex-row-sc"
    }, [(item.coupon_type == 2) ? _c('img', {
      attrs: {
        "src": require("../assets/images/icon-coupon-discount.png"),
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "src": require("../assets/images/icon-coupon-reduce.png"),
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "2.45rem"
      }
    }, [_c('div', {
      staticClass: "fs-30 fw-bold ellipse"
    }, [_vm._v(_vm._s(item.coupon_name))]), _vm._v(" "), _c('div', {
      staticClass: "fs-22",
      staticStyle: {
        "color": "#999",
        "margin-top": ".16rem"
      }
    }, [_vm._v("有效期至：" + _vm._s(item.coupon_end_time))])])]), _vm._v(" "), (item.coupon_type == 2) ? _c('div', {
      staticClass: "price"
    }, [_c('span', [_vm._v(_vm._s(item.amount) + "折")])]) : _c('div', {
      staticClass: "price"
    }, [_vm._v("\n                  ¥"), _c('span', [_vm._v(_vm._s(item.amount))])])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/order-coupon-bottom1.png"),
      "width": "100%",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "jump-btn",
    on: {
      "click": function($event) {
        return _vm.closeCouponAlert()
      }
    }
  }, [_vm._v("立即使用")])])])]) : _vm._e(), _vm._v(" "), (_vm.showNoticeAlert) ? _c('div', {
    staticClass: "notice_detail_alert"
  }, [_c('div', {
    staticClass: "notice_detail_content"
  }, [_c('div', {
    staticClass: "notice_detail_bg"
  }, [_c('h3', [_vm._v("学校公告")]), _vm._v(" "), _c('div', {
    staticClass: "notice_detail_scroll"
  }, _vm._l((_vm.noticeList), function(item) {
    return _c('p', [_vm._v(_vm._s(item))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        _vm.showNoticeAlert = false
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.showAdsvPop) ? _c('div', {
    staticClass: "notice_detail_alert"
  }, [_c('div', {
    staticClass: "notice_detail_content",
    staticStyle: {
      "width": "5.4rem",
      "position": "relative"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.adsvPopItem.imageUrl,
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.bannerJump(_vm.adsvPopItem, '62', 'click_home_top_banner')
      }
    }
  }), _vm._v(" "), (_vm.adsvPopItem.type == 500085) ? _c('wx-open-launch-weapp', {
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "bottom": ".85rem",
      "top": "0",
      "left": "0"
    },
    attrs: {
      "username": JSON.parse(_vm.adsvPopItem.data).miniProgramId,
      "path": JSON.parse(_vm.adsvPopItem.data).path
    }
  }, [_c('script', {
    attrs: {
      "type": "text/wxtag-template"
    }
  }, [_vm._v("\n            <style>.btn{ position: absolute;top:0;left:0;width:100%;height:100%;opacity:0 }</style>\n            <div class=\"btn\"></div>\n          ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "close-btn",
    on: {
      "click": _vm.closeAdsvPop
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.showBonusPop) ? _c('div', {
    staticClass: "notice_detail_alert bonus"
  }, [_c('div', {
    staticClass: "notice_detail_content"
  }, [_c('img', {
    attrs: {
      "src": _vm.bonusPop.icon,
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.bonusPopJump()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        _vm.showBonusPop = false
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.cardPlusInfo && _vm.cardPlusInfo.card) ? _c('div', {
    staticClass: "fixed-card"
  }, [_c('img', {
    attrs: {
      "src": _vm.cardPlusInfo.card,
      "width": "100%"
    },
    on: {
      "click": function($event) {
        return _vm.cardJump()
      }
    }
  })]) : _vm._e()]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    staticStyle: {
      "display": "inline-block",
      "text-decoration": "none",
      "height": "20px",
      "line-height": "20px"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010402004817"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "0.2rem",
      "height": "0.2rem",
      "margin-top": "0.08rem",
      "float": "left"
    },
    attrs: {
      "src": require("../assets/images/record-icon.png")
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "left",
      "height": "20px",
      "line-height": "20px",
      "margin": "0px 0px 0px 5px",
      "color": "#939393"
    }
  }, [_vm._v("沪公网安备\n              31010402004817号")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/order-coupon-title1.png"),
      "width": "100%",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-e2b4e44a","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/TagPage.vue
// module id = 461
// module chunks = 7